/* Tea Lab product page - gallery, quantity, variants, accordion, mobile bar, notify form.
   Add to cart itself is handled by the theme's own product-form-component, so the cart drawer behaves like everywhere else. */
(function () {
  if (customElements.get('tea-lab-product')) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class TeaLabProduct extends HTMLElement {
    connectedCallback() {
      if (this._tlpInit) return;
      this._tlpInit = true;
      this._cleanups = [];
      this._timers = [];
      var json = this.querySelector('[data-tlp-json]');
      try { this.data = JSON.parse(json ? json.textContent : '{}'); } catch (e) { this.data = {}; }
      this.data.variants = this.data.variants || [];
      this.current = this.findVariantById(this.idInput() && this.idInput().value) || this.data.variants[0] || null;
      this.initGallery();
      if (this.current && this.current.mediaId && /[?&]variant=/.test(window.location.search)) this.showMedia(this.current.mediaId, true, true);
      this.preloadSlides();
      this.initQuantity();
      this.initVariants();
      this.initAccordion();
      this.initBar();
      this.initNotify();
      this.initBuyNow();
      this.initCartBadge();
      this.initEditor();
      this.classList.add('is-ready');
    }

    disconnectedCallback() {
      this._tlpInit = false;
      (this._cleanups || []).forEach(function (fn) { try { fn(); } catch (e) {} });
      (this._timers || []).forEach(clearTimeout);
      this._cleanups = [];
      this._timers = [];
      document.body.classList.remove('tlp-has-bar');
    }

    /* ---------- helpers ---------- */
    on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      this._cleanups.push(function () { target.removeEventListener(type, fn, opts); });
    }
    later(fn, ms) { var t = setTimeout(fn, ms); this._timers.push(t); return t; }
    qa(sel) { return [].slice.call(this.querySelectorAll(sel)); }
    idInput() { return this.querySelector('[data-variant-id]'); }
    findVariantById(id) {
      id = Number(id);
      for (var i = 0; i < this.data.variants.length; i++) if (this.data.variants[i].id === id) return this.data.variants[i];
      return null;
    }

    /* ---------- gallery ---------- */
    initGallery() {
      var self = this;
      this.slides = this.qa('.tlp__slide');
      this.thumbs = this.qa('.tlp__thumb');
      this.dots = this.qa('.tlp__dots i');
      this.track = this.querySelector('[data-track]');
      this.index = 0;
      if (!this.track || this.slides.length < 1) return;

      this.thumbs.forEach(function (t, i) {
        self.on(t, 'click', function () { self.show(i, true); });
        self.on(t, 'keydown', function (e) {
          var k = e.key, d = 0;
          if (k === 'ArrowDown' || k === 'ArrowRight') d = 1;
          if (k === 'ArrowUp' || k === 'ArrowLeft') d = -1;
          if (!d) return;
          e.preventDefault();
          var n = (i + d + self.thumbs.length) % self.thumbs.length;
          self.thumbs[n].focus();
          self.show(n, true);
        });
      });

      var st;
      this.on(this.track, 'scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          if (self.isScrollMode()) self.show(Math.round(self.track.scrollLeft / self.track.clientWidth), false);
        }, 60);
      }, { passive: true });

      // keep the current photo in place when the layout flips between desktop and scrolling modes
      if (window.matchMedia) {
        var mq = window.matchMedia('(max-width: 959px)');
        var fn = function () { self.show(self.index, false, true); };
        if (mq.addEventListener) { mq.addEventListener('change', fn); this._cleanups.push(function () { mq.removeEventListener('change', fn); }); }
      }
    }

    isScrollMode() { return this.track && this.track.scrollWidth > this.track.clientWidth + 2; }

    show(i, scroll, instant) {
      if (!this.slides.length) return;
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      if (i !== this.index) this.stopMedia(this.slides[this.index]);
      this.index = i;
      this.slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      this.thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      this.dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      if ((scroll || instant) && this.isScrollMode()) {
        var left = i * this.track.clientWidth;
        if (Math.abs(this.track.scrollLeft - left) > 2) {
          this.track.scrollTo({ left: left, behavior: (instant || reduceMotion) ? 'auto' : 'smooth' });
        }
      }
    }

    showMedia(mediaId, scroll, instant) {
      if (!mediaId) return;
      for (var i = 0; i < this.slides.length; i++) {
        if (Number(this.slides[i].getAttribute('data-media-id')) === Number(mediaId)) { this.show(i, scroll !== false, instant); return; }
      }
    }
    /* a video that was playing keeps going on a hidden slide: pause it (embedded players are reloaded) */
    stopMedia(slide) {
      if (!slide) return;
      try {
        var v = slide.querySelector('video'); if (v && !v.paused) v.pause();
        var f = slide.querySelector('iframe'); if (f && f.src) f.src = f.src;
      } catch (e) {}
    }
    /* photos after the first are lazy; once the page has loaded fetch them so swiping never shows a blank frame */
    preloadSlides() {
      var self = this;
      function go() {
        self.qa('.tlp__slide img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      }
      if (document.readyState === 'complete') self.later(go, 300);
      else this.on(window, 'load', function () { self.later(go, 300); });
    }

    /* ---------- quantity ---------- */
    initQuantity() {
      var self = this;
      this.qtyInput = this.querySelector('[data-qty-input]');
      this.nowQty = this.querySelector('[data-now-qty]');
      this.qtyBtns = this.qa('[data-q]');
      if (!this.qtyInput) return;
      this.qtyBtns.forEach(function (b) {
        self.on(b, 'click', function () { self.setQty(self.qty() + parseInt(b.getAttribute('data-q'), 10)); });
      });
      this.on(this.qtyInput, 'change', function () { self.setQty(self.qty()); });
      this.on(this.qtyInput, 'input', function () { self.syncNow(); });
      this.refreshQty();
    }
    qty() { var n = parseInt(this.qtyInput && this.qtyInput.value, 10); return isNaN(n) ? 1 : n; }
    maxQty() {
      var m = (this.current && this.current.maxQty) || this.data.maxQty || 10;
      return Math.max(1, m);
    }
    setQty(n) {
      if (!this.qtyInput) return;
      n = Math.max(1, Math.min(this.maxQty(), n));
      this.qtyInput.value = n;
      this.refreshQty();
    }
    refreshQty() {
      if (!this.qtyInput) return;
      var max = this.maxQty();
      this.qtyInput.max = max;
      if (this.qty() > max) this.qtyInput.value = max;
      if (this.qty() < 1) this.qtyInput.value = 1;
      var q = this.qty(), dec = this.querySelector('[data-q="-1"]'), inc = this.querySelector('[data-q="1"]');
      if (dec) dec.disabled = q <= 1;
      if (inc) inc.disabled = q >= max;
      this.syncNow();
    }
    syncNow() { if (this.nowQty) this.nowQty.value = this.qty(); }

    /* ---------- variants ---------- */
    initVariants() {
      var self = this;
      var radios = this.qa('[data-opt]');
      if (!radios.length) return;
      radios.forEach(function (r) { self.on(r, 'change', function () { self.onOptionChange(); }); });
    }
    onOptionChange() {
      var picked = [];
      this.qa('[data-opt]:checked').forEach(function (r) { picked[Number(r.getAttribute('data-opt'))] = r.value; });
      var v = null;
      for (var i = 0; i < this.data.variants.length; i++) {
        var o = this.data.variants[i].options || [], ok = true;
        for (var k = 0; k < picked.length; k++) if (o[k] !== picked[k]) { ok = false; break; }
        if (ok) { v = this.data.variants[i]; break; }
      }
      picked.forEach(function (val, k) {
        var el = this.querySelector('[data-opt-val="' + k + '"]');
        if (el) el.textContent = val;
      }, this);
      if (v) this.applyVariant(v);
      else this.applyUnavailableCombo();
    }
    applyUnavailableCombo() {
      this.classList.add('is-soldout');
      var add = this.querySelector('[data-add]'); if (add) add.disabled = true;
      var id = this.idInput(); if (id) id.disabled = true;
      this.syncWeight('');
      this.updateBarState();
    }
    /* weight text (optional): updates every place it is shown and hides separators or empty boxes */
    syncWeight(text) {
      text = text || '';
      var sold = this.classList.contains('is-soldout');
      this.qa('[data-weight]').forEach(function (el) { el.textContent = text; });
      // a dot only shows when there is a weight AND other text beside it
      this.qa('[data-wsep]').forEach(function (el) { el.hidden = !(text && el.getAttribute('data-wo') === '1'); });
      // a box shows when it has a weight or some other text in the current state (in stock / unavailable)
      this.qa('[data-wbox]').forEach(function (box) {
        var other = box.hasAttribute('data-wo-in')
          ? box.getAttribute(sold ? 'data-wo-out' : 'data-wo-in') === '1'
          : box.getAttribute('data-wo') === '1';
        box.hidden = !(text || other);
      });
    }
    applyVariant(v) {
      this.current = v;
      var id = this.idInput(); if (id) { id.value = v.id; id.disabled = !v.available; }
      var nowId = this.querySelector('[data-now-id]'); if (nowId) nowId.value = v.id;
      var add = this.querySelector('[data-add]'); if (add) add.disabled = !v.available;
      this.classList.toggle('is-soldout', !v.available);
      var price = this.querySelector('[data-price]'); if (price) price.textContent = v.price;
      var cmp = this.querySelector('[data-compare]'); if (cmp) { cmp.textContent = v.compare || ''; cmp.hidden = !v.compare; }
      var save = this.querySelector('[data-save]'); if (save) { save.textContent = v.save || ''; save.hidden = !v.compare; }
      var bp = this.querySelector('[data-bar-price]'); if (bp) bp.textContent = v.price;
      var atc = this.querySelector('add-to-cart-component');
      if (atc && v.image) atc.setAttribute('data-product-variant-media', v.image);
      this.syncWeight(v.weight);
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
      this.showMedia(v.mediaId);
      this.refreshQty();
      this.updateBarState();
      // let theme code that watches the variant field know it changed
      if (id) { try { id.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {} }
    }

    /* ---------- accordion ---------- */
    initAccordion() {
      var self = this;
      var multi = this.getAttribute('data-multi') === 'true';
      this.qa('[data-acc]').forEach(function (b) {
        self.on(b, 'click', function () {
          var item = b.closest('.tlp__item');
          var open = !item.classList.contains('is-open');
          if (open && !multi) self.qa('.tlp__item.is-open').forEach(function (o) { if (o !== item) self.setItem(o, false); });
          self.setItem(item, open);
        });
      });
    }
    setItem(item, open) {
      item.classList.toggle('is-open', open);
      var b = item.querySelector('[data-acc]');
      if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    /* ---------- mobile bottom bar ---------- */
    initBar() {
      var self = this;
      this.bar = this.querySelector('[data-bar]');
      this.buybox = this.querySelector('[data-buybox]');
      if (!this.bar || !this.buybox) return;
      this.barBtn = this.querySelector('[data-bar-btn]');
      this.barLabel = this.querySelector('[data-bar-label]');
      this.barHtml = this.barLabel ? this.barLabel.innerHTML : '';
      document.body.classList.add('tlp-has-bar');
      var queued = false;
      function check() {
        queued = false;
        var r = self.buybox.getBoundingClientRect();
        // the bar appears once the real buy box has scrolled out of the top of the screen
        self.barGone = r.height > 0 && r.bottom <= 0;
        self.updateBarState();
      }
      function queue() { if (!queued) { queued = true; window.requestAnimationFrame(check); } }
      this.on(window, 'scroll', queue, { passive: true });
      this.on(window, 'resize', queue);
      this.on(window, 'pageshow', queue);
      queue();
      this.on(this.barBtn, 'click', function () {
        if (self.classList.contains('is-soldout')) { self.goNotify(); return; }
        var add = self.querySelector('[data-add]');
        if (!add || add.disabled) return;
        add.click();
        self.barFeedback(add);
      });
    }
    barRestore() { if (this.barLabel && this.barHtml != null) this.barLabel.innerHTML = this.barHtml; }
    /* the theme marks the button data-added once it accepted the click; if it shows an error instead, take the shopper to it */
    barFeedback(add) {
      var self = this, tries = 0, shown = false;
      clearTimeout(this._barTimer);
      clearTimeout(this._barPoll);
      this.barRestore();
      function poll() {
        var err = self.querySelector('.tlp__err');
        if (err && !err.classList.contains('hidden')) {
          clearTimeout(self._barTimer);
          self.barRestore();
          if (self.buybox) self.buybox.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          return;
        }
        if (!shown && add.getAttribute('data-added') === 'true' && self.barLabel) {
          shown = true;
          self.barLabel.textContent = (self.getAttribute('data-added-label') || 'Added') + ' ✓';
          self._barTimer = self.later(function () { self.barRestore(); }, 1600);
        }
        if (++tries < 15) self._barPoll = self.later(poll, 100);
      }
      poll();
    }
    updateBarState() {
      if (!this.bar) return;
      var show = !!this.barGone;
      if (this.classList.contains('is-soldout') && this.getAttribute('data-notify') !== 'true') show = false;
      this.bar.classList.toggle('is-on', show);
    }
    goNotify() {
      var box = this.querySelector('[data-notify-box] .tlp__notify');
      if (!box) return;
      box.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      var inp = box.querySelector('input[type="email"]');
      if (inp) this.later(function () { try { inp.focus({ preventScroll: true }); } catch (e) { inp.focus(); } }, reduceMotion ? 0 : 500);
    }

    /* ---------- notify me ---------- */
    initNotify() {
      var self = this;
      var form = this.querySelector('[data-notify-form]');
      if (!form || !window.fetch) return;
      this.on(form, 'submit', function (e) {
        var email = form.querySelector('input[type="email"]');
        var msg = self.querySelector('[data-nmsg]');
        var btn = form.querySelector('button[type="submit"]');
        if (!email || !msg) return;
        e.preventDefault();
        if (!email.checkValidity()) { email.reportValidity(); return; }
        if (btn) btn.disabled = true;
        fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
          .then(function (r) {
            var ok = r.ok && /(customer|contact)_posted=true/.test(r.url);
            if (ok) {
              var row = form.querySelector('.tlp__nrow');
              if (row) row.hidden = true;
              var box = form.closest('.tlp__notify');
              msg.className = 'tlp__nmsg is-ok';
              msg.textContent = (box && box.getAttribute('data-ok')) || '';
              try { msg.focus({ preventScroll: true }); } catch (e2) { msg.focus(); }
            } else {
              form.submit(); // let the browser show the normal response (for example a captcha page)
            }
          })
          .catch(function () { form.submit(); });
      });
    }

    /* ---------- buy now: plain form post, so only keep quantity and variant in sync ---------- */
    initBuyNow() {
      var self = this;
      this.syncNow();
      var f = this.querySelector('.tlp__nowform');
      if (!f) return;
      var btn = f.querySelector('[data-now]');
      this.on(f, 'submit', function (e) {
        if (f.getAttribute('data-busy') === '1') { e.preventDefault(); return; }
        f.setAttribute('data-busy', '1');
        if (btn) btn.setAttribute('aria-disabled', 'true');
      });
      // coming back with the browser's back button must not leave the button stuck
      this.on(window, 'pageshow', function () { f.removeAttribute('data-busy'); if (btn) btn.removeAttribute('aria-disabled'); });
    }

    /* ---------- header cart badge ---------- */
    initCartBadge() {
      var self = this;
      function paint(n) {
        n = Number(n) || 0;
        document.querySelectorAll('.tlab-hdr-cart-wrap, .tlab-hdr-stickybar-cart').forEach(function (a) {
          var c = a.querySelector('.tlab-hdr-cart-count');
          if (!c && n > 0) { c = document.createElement('span'); c.className = 'tlab-hdr-cart-count'; a.appendChild(c); }
          if (c) { c.textContent = n; c.hidden = n < 1; }
        });
      }
      function fromCartJson() {
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { paint(c.item_count); }).catch(function () {});
      }
      var wired = false;
      try {
        import('@shopify/events').then(function (m) {
          var name = m && m.StandardEvents && m.StandardEvents.cartLinesUpdate;
          if (!name) throw new Error('no event');
          var h = function (e) {
            if (!e || !e.promise) return;
            e.promise.then(function (res) {
              var cart = res && res.cart;
              if (res && res.detail && res.detail.didError) return;
              if (cart && typeof cart.totalQuantity === 'number') paint(cart.totalQuantity); else fromCartJson();
            }).catch(function () {});
          };
          document.addEventListener(name, h);
          self._cleanups.push(function () { document.removeEventListener(name, h); });
          wired = true;
        }).catch(function () { fallback(); });
      } catch (err) { fallback(); }
      function fallback() {
        var add = self.querySelector('[data-add]');
        if (!add || !('MutationObserver' in window)) return;
        var mo = new MutationObserver(function () { if (add.getAttribute('data-added') === 'true') self.later(fromCartJson, 700); });
        mo.observe(add, { attributes: true, attributeFilter: ['data-added'] });
        self._cleanups.push(function () { mo.disconnect(); });
      }
    }

    /* ---------- theme editor ---------- */
    initEditor() {
      var self = this;
      this.on(this, 'shopify:block:select', function (e) {
        var item = e.target && e.target.closest && e.target.closest('.tlp__item');
        if (item) self.setItem(item, true);
      });
    }
  }

  customElements.define('tea-lab-product', TeaLabProduct);
})();
